export default class Size {
  public width = 0;
  public height = 0;

  constructor(width: number, height: number) {
    this.width = width;
    this.height = height;
  }
}
